import { isFocused } from '../../utils/focus.js';

function selectInput(el, shared) {
    if (isFocused(el)) {
        if (shared?.select) {
            shared.select(el);
        }
        else {
            el.select();
        }
    }
}

export { selectInput };
//# sourceMappingURL=inputs.hooks.utils.js.map
